module.exports = __webpack_public_path__ + "static/img/01_03.ee718761.jpg";